import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommunicationService } from 'app/_services/communication.service';
import { WidgetService } from 'app/_services/widget.service';
import { AppComponent } from 'app/app.component';
import { ISettings } from 'app/_models/ISettings';
import { IWidget } from 'app/_models/IWidget';
import { RADController } from 'app/_controllers/radController';
import { IWidgetRow } from 'app/_models/IWidgetRow';
import { IconDefinition as IconDefinitionSolid, faArrowsLeftRight, faArrowUp, faArrowDown, faArrowTrendDown, faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import { IWidgetExpanded } from 'app/_models/IWidgetExpanded';
import { WidgetController } from 'app/_controllers/widgetController';

@Component({
  selector: 'widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css']
})
export class WidgetComponent implements OnInit {
  //#region Fields & Icons 
  @Input() settings!: ISettings;
  @Input() userId!: string;
  @Input() nodeId!: string;
  @Output() widgets = new EventEmitter<IWidget[]>();
  widgetData: IWidget[] = [];
  widgetRows!: IWidgetRow[][];
  maximised: boolean = false;
  widgetsLoaded: boolean = false;
  i!: number;
  maxRows: number = 0;
  maxCols: number = 0;
  gridItems: IWidgetExpanded[] = [];
  widgetsGridLoaded = false;
  faArrowsLeftRight: IconDefinitionSolid = faArrowsLeftRight;
  faArrowUp: IconDefinitionSolid = faArrowUp;
  faArrowDown: IconDefinitionSolid = faArrowDown;
  faArrowTrendDown: IconDefinitionSolid = faArrowTrendDown;
  faArrowTrendUp: IconDefinitionSolid = faArrowTrendUp;
  //#endregion

  constructor(
    private app: AppComponent,
    private communicationService: CommunicationService,
    private widgetService: WidgetService,
    private radController: RADController,
    private widgetController: WidgetController
  ) { }
  
  ngOnInit(): void {
    let formData = this.app.buildForm(['userId', 'nodeId'], [this.userId, this.nodeId]);
    this.widgetService.getWidgetData(formData).subscribe({
      next: (data: IWidget[]) => {
        this.widgetData = data;           
        this.i = 0;
        this.getInfoOnWidgets();
      },
      error: (errorLog) => { console.log(errorLog); }
    });
  }

  getInfoOnWidgets(): void {
    if (this.i == this.widgetData.length) {
      this.widgets.emit(this.widgetData);      
      this.widgetRows = this.widgetController.buildWidgetRows(this.widgetData, this.maximised);      
      this.widgetsLoaded = true;
      return;
    }

    let widget = this.widgetData[this.i];
    this.radController.executeSqlStatement(widget.data, this.userId).then(result => {      
      if (result.tableData) {        
        if (widget.type == 'RAG') {
          widget.value = JSON.parse(result.tableData)[0].StatusColor;          
        } else if (widget.type == 'Progress Bar') {
          widget.value = JSON.parse(result.tableData)[0];          
        } else if (!widget.type.includes('Chart')) {
          let data = JSON.parse(result.tableData)[0];
          widget.value = data.VALUE;
          widget.subText = data.SUBTEXT;
          if (data.TREND) widget.trend = data.TREND;
        } else {
          widget.chartData = JSON.parse(result.tableData);
        }        
      }

      this.i++;
      this.getInfoOnWidgets();
    });
  }  

  toggleWidgetSize(): void {
    this.maximised = !this.maximised;
    this.widgetsLoaded = false;
    this.communicationService.toggleMaxWidgets();
    this.widgetRows = [];
    this.widgetRows = this.widgetController.buildWidgetRows(this.widgetData, this.maximised);  
  }

  getBackgroundClass(item: IWidgetRow): string {
    if (!item.widget.type.includes('Chart') && item.widget.type != 'RAG') {
      if (item.widget.backGroundColor == '') return 'green-gradient';
      return item.widget.backGroundColor;
    }
    
    return this.settings.darkModeSetting ? 'bg-dark' : 'bg-white';
  }

  calculatePercentage(min: number, max: number, value: number): string {      
    return `${((value - min) / (max - min)) * 100}%`;
  }
}